import styles from './branch.module.scss'
import React, { useState, useEffect, useRef } from 'react'
import moment from 'moment'
import noimage from 'assets/img/noimage.jpg'
import { compare, filterOptionSelect, copyText } from 'utils'

//antd
import { Input, Row, Col, Table, Popover, Button, Popconfirm, notification, Select } from 'antd'

//icons
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons'

//components
import BranchForm from './branch-form'

//apis
import { deleteBranch, getBranches } from 'apis/branch'
import { getCountries } from 'apis/country'
import { getRegions } from 'apis/region'

const HOST_LINK_COMMENT = 'https://elgaucho.asia'
export default function Branch() {
  const typingTimeoutRef = useRef(null)
  const { Option } = Select

  const [loading, setLoading] = useState(false)
  const [locations, setLocations] = useState([])
  const [countries, setCountries] = useState([])
  const [regions, setRegions] = useState([])
  const [allRegion, setAllRegion] = useState([])
  const [countLocation, setCountLocation] = useState(0)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20, is_show_password: true })

  const [valueSearch, setValueSearch] = useState('')
  const onSearch = (e) => {
    setValueSearch(e.target.value)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value
      if (value) paramsFilter.name = value
      else delete paramsFilter.name

      paramsFilter.page = 1
      setParamsFilter({ ...paramsFilter })
    }, 650)
  }

  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setCountries(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  const _getRegions = async (params) => {
    try {
      const res = await getRegions(params)

      if (res.status === 200) setRegions(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  const _getAllRegion = async () => {
    try {
      const res = await getRegions()
      if (res.status === 200) setAllRegion(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  const _getBranches = async () => {
    try {
      setLoading(true)
      const res = await getBranches({ ...paramsFilter })
      if (res.status === 200) {
        setLocations(res.data.data)
        setCountLocation(res.data.count)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const _deleteBranch = async (id) => {
    try {
      setLoading(true)
      const res = await deleteBranch([id])
      if (res.status === 200) {
        if (res.data.success) {
          _getBranches()
          notification.success({ message: 'Xóa chi nhánh thành công' })
        } else
          notification.error({
            message: res.data.message || 'Xóa chi nhánh thất bại, vui lòng thử lại',
          })
      } else
        notification.error({
          message: res.data.message || 'Xóa chi nhánh thất bại, vui lòng thử lại',
        })
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const contentImage = (data) => (
    <img src={data} style={{ width: '25rem', height: '15rem', objectFit: 'contain' }} alt="" />
  )
  const columns = [
    {
      title: 'STT',
      render: (text, record, index) => (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
    },
    {
      title: 'Hình ảnh',
      render: (text, record) =>
        record.image_urls && record.image_urls.length ? (
          <Popover content={() => contentImage(record.image_urls[0])}>
            <div>
              <img
                src={record.image_urls[0]}
                style={{ width: 50, height: 50, objectFit: 'cover' }}
                alt=""
              />
            </div>
          </Popover>
        ) : (
          <img src={noimage} style={{ width: 50, height: 50, objectFit: 'cover' }} alt="" />
        ),
    },
    {
      title: 'Tên chi nhánh',
      dataIndex: 'name',
      render: (text, record) => (
        <BranchForm regions={allRegion} reloadData={_getBranches} infoBranch={record}>
          <a>{text}</a>
        </BranchForm>
      ),
      sorter: (a, b) => compare(a, b, 'name'),
    },
    {
      width: 100,
      title: 'Ưu tiên hiển thị',
      render: (text, record) => <div>{record.priority ? record.priority : 'Chưa cài đặt'}</div>,
    },
    {
      title: 'Khu vực',
      render: (text, record) => record.region_info && record.region_info.name,
    },
    {
      title: 'Quốc gia',
      render: (text, record) => record.country_info && record.country_info.name,
    },
    {
      title: 'Liên hệ',
      dataIndex: 'phone',
      sorter: (a, b) => compare(a, b, 'phone'),
    },
    {
      title: 'Email',
      render: (text, record) => record.email,
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'address',
      sorter: (a, b) => compare(a, b, 'address'),
    },
    {
      title: 'Giờ mở cửa',
      dataIndex: 'date_open',
      sorter: (a, b) => compare(a, b, 'date_open'),
    },
    {
      title: 'Giờ đóng cửa',
      dataIndex: 'date_close',
      sorter: (a, b) => compare(a, b, 'date_close'),
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'create_date',
      render: (text, record) => (text ? moment(text).format('DD-MM-YYYY HH:mm') : ''),
      sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
    },
    {
      title: 'Link nhận xét',
      render: (text, record) => (
        <a
          onClick={() =>
            copyText(`${HOST_LINK_COMMENT}/submit-comment?branch_id=${record.branch_id}`)
          }
        >
          Copy link
        </a>
      ),
    },
    {
      title: 'Hành động',
      render: (text, record) => (
        <Popconfirm
          onConfirm={() => _deleteBranch(record.branch_id)}
          title="Bạn có muốn xóa chi nhánh này không?"
        >
          <Button icon={<DeleteOutlined />} type="primary" danger />
        </Popconfirm>
      ),
    },
  ]

  const _clearFilters = () => {
    setParamsFilter({ page: 1, page_size: 20 })
    setValueSearch('')
  }

  useEffect(() => {
    _getBranches()
  }, [paramsFilter])

  useEffect(() => {
    _getCountries()
    _getRegions()
    _getAllRegion()
  }, [])

  return (
    <div className={`${styles['promotion_manager']} ${styles['card']}`}>
      <Row
        wrap={false}
        align="middle"
        justify="space-between"
        style={{ borderBottom: '1px solid rgb(236, 226, 226)', paddingBottom: '0.75rem' }}
      >
        <div style={{ fontWeight: '600', fontSize: '1.2rem' }}>Quản lý chi nhánh</div>
        <BranchForm regions={allRegion} reloadData={_getBranches}>
          <Button size="large" icon={<PlusCircleOutlined />} type="primary">
            Thêm chi nhánh
          </Button>
        </BranchForm>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
        <Col xs={24} sm={24} md={11} lg={11} xl={7}>
          <Input
            size="large"
            style={{ width: '100%' }}
            name="name"
            value={valueSearch}
            enterButton
            onChange={onSearch}
            placeholder="Tìm kiếm theo tên chi nhánh"
            allowClear
          />
        </Col>
        <Col xs={24} sm={24} md={11} lg={11} xl={7}>
          <Select
            showSearch
            size="large"
            style={{ width: '100%' }}
            name="country_id"
            enterButton
            onChange={(e) => {
              setParamsFilter({ ...paramsFilter, country_id: e })
              _getRegions({ country_id: e })
            }}
            // filterOption={(input, option) =>
            //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            // }
            placeholder="Lọc theo quốc gia"
            allowClear
          >
            {countries.map((info) => (
              <Option value={info.country_id}>{info.name}</Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={24} md={11} lg={11} xl={7}>
          <Select
            showSearch
            size="large"
            style={{ width: '100%' }}
            name="region_id"
            enterButton
            onChange={(e) => setParamsFilter({ ...paramsFilter, region_id: e })}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            placeholder="Lọc theo khu vực"
            allowClear
          >
            {regions.map((info) => (
              <Option value={info.region_id}>{info.name}</Option>
            ))}
          </Select>
        </Col>
        <Button
          style={{ display: Object.keys(paramsFilter).length < 3 && 'none' }}
          size="large"
          onClick={_clearFilters}
          type="primary"
          danger
        >
          Xóa bộ lọc
        </Button>
      </Row>

      <Table
        size="small"
        rowKey="_id"
        loading={loading}
        columns={columns}
        dataSource={locations}
        style={{ width: '100%', marginTop: 20 }}
        pagination={{
          position: ['bottomLeft'],
          current: paramsFilter.page,
          pageSize: paramsFilter.page_size,
          pageSizeOptions: [20, 30, 40, 50, 70, 100],
          showQuickJumper: true,
          onChange: (page, pageSize) =>
            setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
          total: countLocation,
        }}
      />
    </div>
  )
}
